<div
  data-testid="slotcom-multiplier-prize"
  class="c-multiplierPrize">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-multiplierPrize__container">
    <div
      class="c-multiplierPrize__background"
      theming
      themingGroup="multiplierprize"
      themingAsset="start-background"
      [themingOverride]="event?.assets">
      <div class="c-multiplierPrize__info">
        <div
          class="c-multiplierPrize__tag"
          theming
          themingGroup="multiplierprize"
          themingAsset="multiplier"
          [themingOverride]="event?.assets"></div>

        <slotcom-box
          class="maxCompletionTimes"
          [classes]="['maxCompletionTimes--blue']">
          @if (!event.infiniteTimes && event.maxCompletionTimes === 1) {
            <span class="text times">{{ 'home.live-ops.global.times-valid-coins' | translate }}</span>
          }
          @if (!event.infiniteTimes && event.maxCompletionTimes > 1) {
            <span class="text times">{{
              'home.live-ops.global.times-valid-coins-2' | translate: { times: event.maxCompletionTimes }
            }}</span>
          }
          @if (event.infiniteTimes) {
            <span class="text times">{{ 'home.live-ops.global.times-valid-coins-3' | translate }}</span>
          }
        </slotcom-box>

        <div class="c-multiplierPrize__timer">
          <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
          <slotcom-animated-timer
            [showInDays]="true"
            [endDate]="event.endDate"
            (expired)="closeModal()"></slotcom-animated-timer>
        </div>
      </div>

      <slotcom-button
        data-testid="slotcom-multiplier-button"
        class="c-button--pink"
        (safeClick)="closeModal()"
        audioType="functionality">
        {{
          persistedModalData?.properties?.buttonText?.[lang]
            ? persistedModalData.properties.buttonText[lang]
            : ('home.buttons.discover-offers' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </div>
</div>
